import XLSX from 'xlsx';
import saveAs from 'file-saver';

export default {
  methods: {
    downloadFromHTML(fileName) {
      const options = {
        bookType: 'xlsx',
        bookSST: false,
        type: 'binary'
      };

      const workbook = {SheetNames: [], Sheets: {}};

      document.querySelectorAll('table.table-to-export').forEach( (currentValue, index) => {
        // sheet_to_workbook()の実装を参考に記述
        let n = currentValue.getAttribute('data-sheet-name');
        if (!n) {
          n = 'Sheet' + index;
        }
        workbook.SheetNames.push(n);
        workbook.Sheets[n] = XLSX.utils.table_to_sheet(currentValue, options);
      });

      const output = XLSX.write(workbook, options);

      function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) {
          view[i] = s.charCodeAt(i) & 0xFF;
        }
        return buf;
      }

      saveAs(new Blob([s2ab(output)], {type: 'application/octet-stream'}), `${fileName}.xlsx`);
    },

  },
}